import axios, { AxiosRequestConfig } from 'axios'
import Cognito from 'src/utils/Cognito'
import { API_URL } from 'src/utils/Constants'
import APIError from './apiError'

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-type': 'application/json;charset=UTF-8',
  },
  timeout: 1000 * 300, // ms
})

type Data = { [key: string]: any }

const getHeaders = async (withAuth: boolean): Promise<AxiosRequestConfig['headers']> => {
  if (!withAuth) return {}

  const token = await Cognito.getAccessToken()
  return {
    Authorization: `Bearer ${token}`,
  }
}

// Requests ------------

export const get = async <D>(path: string, params: Data = {}, withAuth = true): Promise<D> => {
  const headers = await getHeaders(withAuth)

  try {
    const { data } = await api.get(path, { params, headers })

    return data as D
  } catch (error) {
    console.error(error)
    throw new APIError(error.response?.data?.error || 'エラーが発生しました')
  }
}

export const post = async <D>(path: string, body: unknown, withAuth = true): Promise<D> => {
  const headers = await getHeaders(withAuth)

  try {
    const { data } = await api.post(path, body, { headers })
    return data as D
  } catch (error) {
    console.error(error)
    throw new APIError(error.response?.data?.error || 'エラーが発生しました')
  }
}

export const put = async <D>(path: string, body: unknown, withAuth = true): Promise<D> => {
  const headers = await getHeaders(withAuth)

  try {
    const { data } = await api.put(path, body, { headers })
    return data as D
  } catch (error) {
    console.error(error)
    throw new APIError(error.response?.data?.error || 'エラーが発生しました')
  }
}

export const deleteRequest = async <D>(path: string, body: unknown = {}, withAuth = true): Promise<D> => {
  const headers = await getHeaders(withAuth)

  try {
    const { data } = await api.delete(path, { data: body, headers })
    return data as D
  } catch (error) {
    console.error(error)
    throw new APIError(error.response?.data?.error || 'エラーが発生しました')
  }
}
